export default "__VITE_ASSET__91bc589c__"